import { motion } from 'framer-motion';

const StatementOfPurpose = ({ content }) => {
  if (!content) return null;

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-slate-100 overflow-hidden" data-testid="statement-section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, x: -60, scale: 0.95 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            viewport={{ once: true, margin: "-80px" }}
          >
            <img
              src="https://securethevotemd.com/images/2025/03/2025-Feb-25-Secure-the-Vorte-66-1024x683.jpg"
              alt="Secure the Vote Maryland gathering"
              className="w-full rounded-lg shadow-lg"
              data-testid="statement-image"
            />
          </motion.div>

          {/* Content */}
          <div>
            <motion.h2
              className="text-3xl sm:text-4xl font-bold text-slate-900 mb-6"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid="statement-title"
            >
              {content.statement_title}
            </motion.h2>
            <div className="space-y-4">
              {content.statement_text?.split('\n').map((line, index) => (
                <motion.p
                  key={index}
                  className="text-lg text-slate-600 leading-relaxed"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.25 + index * 0.1 }}
                  viewport={{ once: true, margin: "-80px" }}
                  data-testid={`statement-text-${index}`}
                >
                  {line}
                </motion.p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatementOfPurpose;

